import {AxiosError} from 'axios';
import {POST_CREATE_ADMIN_PROFILE_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateAdminProfile = ({onError, onSuccess}: Input = {}) => {
  const postCreateAdminProfile = async (reqBody: any) => {
    const res = await axiosClient.post<void>(POST_CREATE_ADMIN_PROFILE_URL, reqBody);

    return res.data;
  };

  return useCustomMutation(postCreateAdminProfile, {
    onSuccess,
    onError,
  });
};
